<template>
    <v-autocomplete
        v-bind:value="value"
        :items="sortedItems"
        label="Templates"
        :color="ada.blue"
        item-value="completeKey"
        item-text="completeKey"
        flat
        clearable
        return-object
        no-data-text="Keine Daten"
        @input="$emit('input', $event)"
    >
        <template v-slot:selection="data">
            <v-chip class="font-weight-bold mr-3 typeName" dark label small
                    color="blue-grey lighten-1"
                    style="min-width: 80px; justify-content: center;">
                {{ data.item.type.name }}
            </v-chip>
            <div class=" d-flex flex-wrap align-center">
                <span class="mr-3">{{ data.item.positions.join(', ') }}</span>
                <div>
                    <v-chip
                        v-for="(teasertype, i) in data.item.teasertypes" :key="'teasertype_'+i"
                        class="font-weight-bold mr-3" label x-small
                        color="blue-grey lighten-4" style="padding:10px 10px;">
                        {{ teasertype }}
                    </v-chip>
                </div>
            </div>
        </template>

        <template v-slot:item="data">
            <v-chip class="font-weight-bold mr-3 typeName" dark label small
                    color="blue-grey lighten-1"
                    style="min-width: 80px; justify-content: center;">
                {{ data.item.type.name }}
            </v-chip>
            <div class=" d-flex flex-wrap">
                <span class="mr-4">{{ data.item.positions.join(', ') }}</span>
                <div>
                    <v-chip
                        v-for="(teasertype, i) in data.item.teasertypes" :key="'teasertype_'+i"
                        class="font-weight-bold mr-3" label x-small
                        color="blue-grey lighten-4" style="padding:10px 10px;">
                        {{ teasertype }}
                    </v-chip>
                </div>
            </div>
        </template>
    </v-autocomplete>
</template>

<script>
import ada from "../../../scss/ada_colors.scss";
import Utils from "../../../scripts/Utils";

export default {
    name: "JsonTemplatesDropdown",
    props: {
        value: {},
        items: {
            required: true
        }
    },
    data: () => {
        return {
            ada,
        }
    },
    computed: {
        sortedItems() {
            return Utils.sortJsonKeys(this.items);
        }
    }
}
</script>

<style scoped>

</style>